// Asset cache-busting. The sprite sheets live in public/assets with FIXED filenames, so Vite does NOT
// content-hash them (only imported JS/CSS get hashes). On a CDN deploy (Render) the browser + edge
// cache those fixed URLs, so re-rendering a sheet doesn't change its URL and stale (old, lower-quality)
// art keeps being served. Appending ?v=<build version> gives every build a fresh URL → guaranteed
// fresh assets on deploy, while staying fully cached within a build (no per-load revalidation).
//
// `__ASSET_VERSION__` is injected by vite.config.ts at build time (the deploy commit SHA, else a build
// timestamp). In dev it's "dev" (no CDN, so caching is a non-issue).
declare const __ASSET_VERSION__: string | undefined;
export const ASSET_VERSION: string =
  typeof __ASSET_VERSION__ !== "undefined" && __ASSET_VERSION__ ? __ASSET_VERSION__ : "dev";

/** Append the build version to a same-origin asset path. Skips data:/blob:/remote URLs (already
 *  immutable/inline) and anything already carrying ?v=. */
export function assetUrl(path: string): string {
  if (!path || /^(data:|blob:|https?:)/i.test(path) || /[?&]v=/.test(path)) return path;
  return path + (path.includes("?") ? "&" : "?") + "v=" + ASSET_VERSION;
}
